var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVajra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 1564,
    viewBox: "0 0 900 1564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 788.012L450.5 13.7627L900 788.012L450.5 1563.76L0 788.012Z",
    fill: "#EB7E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M586 704.262L450.5 35L677.5 792.762L396 730.262L450.5 1543L319.322 649.285L586 704.262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVajra);
export default __webpack_public_path__ + "static/media/vajra.e58a3c93072615e765811bead2f9511d.svg";
export { ForwardRef as ReactComponent };